import { useAxios } from '../../config/axios'
import { getConfig } from './config'

const useApiJobs = async (payload) => {
  const {
    endpoint = 'jobs',
    method = 'get',
    params = {},
    url = '',
    data,
  } = payload

  const config = getConfig({ method })
  const { baseURL, endpoints } = config

  const result = await useAxios({
    baseURL,
    headers: { ...payload.headers, ...config.headers },
    endpoint: `${endpoints[endpoint]}${url}`,
    method,
    params,
    data,
  })

  return result
}
export { useApiJobs }
